// extracted by mini-css-extract-plugin
module.exports = {"LinkBase":"LinkText_LinkBase__148dT","LinkPrimary":"LinkText_LinkPrimary__FkBup"};